import { Link } from "react-router-dom";
import { CONTACT } from "../data/content";

export const Footer = () => (
    <footer className="bg-forest-deep border-t border-forest-line text-white/60 pb-24 md:pb-0" data-testid="site-footer">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-16">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
                <div>
                    <img src="/logo-light.png" alt="Julians Gartenservice" className="h-12 w-auto" />
                    <p className="mt-5 text-sm leading-relaxed max-w-xs">
                        Professionelle Gartenpflege &amp; Außenreinigung im Landkreis Celle.
                        Reinigung — Pflege — Werterhalt.
                    </p>
                </div>
                <div>
                    <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/40 mb-4">Kontakt</p>
                    <ul className="space-y-2.5 text-sm">
                        <li><a href={CONTACT.phoneHref} className="hover:text-white transition-colors duration-200">{CONTACT.phoneDisplay}</a></li>
                        <li><a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors duration-200">{CONTACT.email}</a></li>
                        <li className="text-white/40">Landkreis Celle, Niedersachsen</li>
                    </ul>
                </div>
                <div>
                    <p className="font-mono text-[11px] uppercase tracking-[0.25em] text-white/40 mb-4">Leistungen in Celle</p>
                    <ul className="space-y-2 text-sm">
                        <li><Link to="/heckenschnitt-celle" data-testid="footer-link-heckenschnitt" className="hover:text-white transition-colors duration-200">Heckenschnitt &amp; Heckenpflege</Link></li>
                        <li><Link to="/hochdruckreinigung-celle" data-testid="footer-link-hochdruckreinigung" className="hover:text-white transition-colors duration-200">Hochdruck- &amp; Pflasterreinigung</Link></li>
                        <li><Link to="/rasenpflege-celle" data-testid="footer-link-rasenpflege" className="hover:text-white transition-colors duration-200">Rasenpflege &amp; Rasenreparatur</Link></li>
                        <li><Link to="/gartenpflege-celle" data-testid="footer-link-gartenpflege" className="hover:text-white transition-colors duration-200">Gartenpflege &amp; Laubentfernung</Link></li>
                        <li><Link to="/angebot" data-testid="footer-link-angebot" className="hover:text-white transition-colors duration-200">Angebot anfragen</Link></li>
                    </ul>
                </div>
            </div>
            <div className="mt-14 pt-7 border-t border-forest-line flex flex-col sm:flex-row items-center justify-between gap-4">
                <p className="text-xs text-white/35">© 2026 Julians Gartenservice. Alle Rechte vorbehalten.</p>
                <div className="flex gap-6 text-xs text-white/35">
                    <Link to="/impressum" data-testid="footer-impressum" className="hover:text-white/70 transition-colors duration-200">Impressum</Link>
                    <Link to="/datenschutz" data-testid="footer-datenschutz" className="hover:text-white/70 transition-colors duration-200">Datenschutz</Link>
                </div>
            </div>
        </div>
    </footer>
);
